import { t } from "i18next";

import type { MetaMatches } from "@remix-run/react/dist/routeModules";

export const BRAND_NAME = "AcademIA";

/**
 * "Iniciar sesión · AcademIA". Una sola forma para todas las pestañas de la app.
 *
 * Antes dependía de `companyShortName` (dato del fork que llega por el loader del layout):
 * cuando no venía, la pestaña quedaba sin marca ("Login", "Admin"), y cuando venía salía al
 * revés ("AcademIA - Cursos"). La marca es fija, así que no hace falta leerla de ningún lado.
 */
export const buildPageTitle = (label?: string | null) => {
  const clean = label?.trim();
  return clean ? `${clean} · ${BRAND_NAME}` : BRAND_NAME;
};

/**
 * Para el `meta` de una ruta. `tKey` puede ser una clave de i18n o un texto ya escrito: si no
 * existe como clave, i18next devuelve el mismo texto.
 */
export const setPageTitle = (_matches: MetaMatches<Record<string, unknown>>, tKey: string) => [
  { title: buildPageTitle(t(tKey)) },
];
